export default "__VITE_ASSET__ByiXnOUG__"